import React, { useEffect, useState, useRef } from 'react';
import {
    Typography,
    Paper,
    InputAdornment,
    Dialog,
    Grid,
    Button
} from '@material-ui/core';
import { connect } from "react-redux";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { DialogTitle, DialogContent, DialogActions } from '../Dialog/Dialog';
import { Radios, Switches, TextField } from 'mui-rff';
import { Form } from 'react-final-form';
import * as logger from "../../../logger";
import { sendSucces, sendError } from "../../../utils/utils";
import { editDriver } from '../../../store/actions/vehicleActionCreator';
import { withRouter, useHistory, useLocation } from 'react-router-dom';


const useStyles = makeStyles(() => ({

    divAlign: {
        display: 'flex'
    },
    divAlignV1: {
        display: 'flex',
        marginTop: 16,
        alignItems: 'baseline'
    },
    cancelButton: {
        textTransform: 'capitalize', marginRight: '16px', fontWeight: 300, backgroundColor: '#f6f7f9', paddingLeft: '20px', paddingRight: 20, paddingTop: 9, paddingBottom: 11,
        "&:hover": {
            backgroundColor: '#f6f7f9'
        }
    },
    confirmV1: {
        backgroundColor: 'black',
        color: 'white',
        textTransform: 'capitalize',
        fontWeight: 300,
        paddingLeft: 36,
        paddingRight: 36,
        paddingTop: 9,
        paddingBottom: 11,
        "&:hover": {
            backgroundColor: 'black'
        }
    },
    title: {
        color: '#9ea0a5',
        fontSize: 12,
        fontWeight: 500,
        marginTop: 18
    },
    titleV1: {
        color: '#9ea0a5',
        fontSize: 12,
        fontWeight: 500,
    },
    marginV1: {
        marginTop: 4
    },
    formHelperText: {
        color: '#9ea0a5',
        fontSize: 11,
        marginTop: 4,
    },
    switch: {
        '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
            backgroundColor: '#0033cc'
        },
        '& .MuiSwitch-colorSecondary.Mui-checked': {
            color: '#0033cc'
        },
        marginLeft: 14
    },
    divV1: {
        fontSize: 14,
        fontWeight: 300
    }

}));

const EditDriverDialog = ({ open, onClose, onConfirm, driverData, dispatchEditDriver }) => {

    let submit;

    const [dialogopen, setDialogOpen] = useState(open);
    const [driverName, setDriverName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [smsToggle, setSmsToggle] = useState(false);

    let location = useLocation();
    let path = location && location.pathname ? location.pathname.split("/") : [];
    let driverIdValue = path && path[path.length - 1] ? path[path.length - 1] : "";

    const classes = useStyles();

    useState(() => {

        setDriverName(driverData && driverData.name ? driverData.name : "");
        setPhoneNumber(driverData && driverData.contactNumber ? driverData.contactNumber : "");
        setSmsToggle(driverData && driverData.sendSMS ? true : false);

    }, [driverData]);

    const initialValues = {
        name: driverName,
        mobileNumber: phoneNumber ? (phoneNumber.replace(/(\d{5})(\d{5})/, "$1-$2")).trim() : "",
        driverSms: smsToggle
    }

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div>
                            <div className={classes.titleV1}>Driver Name</div>
                            <TextField
                                placeholder="Enter Driver Name"
                                name="name"
                                variant="outlined"
                                size="small"
                                onChange={(e) => {
                                    if (e && e.target && e.target.value && ((e.target.value).trim()).length > 0) {
                                        setDriverName(e.target.value)
                                    } else {
                                        setDriverName("");
                                    }
                                }
                                }
                                className={classes.marginV1}
                            />
                        </div>
                    </>
                ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <div className={classes.marginV2}>
                            <div className={classes.title}>Mobile Number</div>
                            <TextField
                                placeholder="Enter Mobile Number"
                                name="mobileNumber"
                                variant="outlined"
                                size="small"
                                onChange={(e) => {
                                    if (e && e.target && e.target.value && ((e.target.value).trim()).length > 0) {
                                        setPhoneNumber(e.target.value)
                                    } else {
                                        setPhoneNumber("");
                                    }
                                }}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">+91</InputAdornment>
                                }}
                                className={classes.marginV1}
                            />
                            <div className={classes.formHelperText}>Optional</div>
                        </div>
                    </>
                ),
            },
            {
                size: 12,
                visible: true,
                field: (
                    <div className={classes.divAlignV1} >
                        <div className={classes.divV1}>Enable SMS for transactions</div>
                        <Switches
                            size='small'
                            margin='normal'
                            formControlProps={{
                                className: classes.switchControl
                            }}
                            onChange={() => { setSmsToggle(!smsToggle) }}
                            className={classes.switch}
                            name="driverSms"
                            data={{ label: '', value: true }} label="" />
                    </div>
                )
            }
        ]
    }

    const onSubmit = (values) => {

        const driverRequestData = {
            name: values.name,
            contactNumber: values.mobileNumber ? values.mobileNumber.replace("-", "") : null,
            sendSMS: values.driverSms
        }

        dispatchEditDriver(driverIdValue, driverRequestData,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Edit Driver Dialog Dweb", "Edit Driver Successfull");
                    setDialogOpen(false);
                    sendSucces("Driver Updated Successfully.");
                    onConfirm();
                }
            },
            () => {
                logger.log("Edit Driver Dialog Dweb", "Edit Driver Failed");
            }
        )

    }

    const validate = values => {

        const errors = {}

        let number = values.mobileNumber ? /^[1-9]{1}[0-9]{9}$/.test(values.mobileNumber.replace("-", "")) : "";

        if (values && !values.name) {
            errors.name = "Please enter valid name."
        }

        if (values.mobileNumber && !number) {
            errors.mobileNumber = "Please enter valid 10-digit mobile number."
        }

        return errors;

    }

    return (
        <>
            <Dialog fullWidth={true}
                maxWidth='xs'
                onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} open={dialogopen}>
                <DialogTitle id="edit-driver-dialog-title" onClose={handleClose}>
                    <div>Edit Driver Details</div>
                </DialogTitle>
                <DialogContent dividers>
                    <Form
                        onSubmit={onSubmit}
                        initialValues={initialValues}
                        validate={validate}
                        id="myForm"
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit
                            return (
                                <form onSubmit={handleSubmit} noValidate id="myForm">
                                    <Grid container alignItems="flex-start">
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                </form>
                            )
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <div className={classes.divAlign}>
                        <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()} >
                            Close
                        </Button>
                        <Button className={classes.confirmV1} type="submit" variant="contained"
                            onClick={event => {
                                submit(event)
                            }}
                        >
                            Confirm
                        </Button>
                    </div>
                </DialogActions>
            </Dialog>
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchEditDriver: (id, data, onSuccess, onFailure) => {
        dispatch(editDriver(id, data, onSuccess, onFailure))
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(EditDriverDialog)